import React from 'react'
import { Navigate, useLocation } from 'react-router'

export default function RedirectToPlural() {
  const location = useLocation()
  const match = location.pathname.match(/^\/([^/]+)/)

  if (!match) {
    return
  }

  const newPath = location.pathname.replace(match[1], match[1] + 's')
  return <Navigate to={newPath + location.search + location.hash} replace />
}
